'use strict';

module.exports = require('./_and-or')(function (x) { return !x; });
